module.exports = __webpack_public_path__ + "static/media/collaborative-whiteboard.a8f60b33.svg";